import React, { Component } from "react";
import ImageHeroContainer from "./../shared/containers/ImageHeroContainer";
import Store from "../../content/Store";
import OuterPrimaryContainer from "../shared/containers/OuterPrimaryContainer";
import Contentify from "../../content/Contentify";
import styles from "../../assets/css/modules/health-support/working-body.css";
// import btnStyles from "../../assets/css/modules/myprofile/myprofile.css";
import { Paths, Urls } from "./../../constants/UrlConstants";
import HelpSection from "./../shared/HelpSection";
// import NumberStepList from "../shared/groups/NumberStepList";
// import Button from "../../components/shared/buttons/Button";
import Scroll from "react-scroll";
import { HOW_TO_BOOK_APPOINTMENT } from "../polices/PolicyConstants";
import PromoImageCard from "../shared/PromoImageCard";
import StyledButton from "../shared/buttons/StyledButton";
import { connect } from "react-redux";
import { Layouts,ButtonConfig } from "../../constants/Constants";
import btnStyles from "../../assets/css/modules/health-support/ask-a-medical-expert.css";
import { SendPolicyNumberToHBS } from "../../services/HbsService";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";
import { Redirect } from "react-router-dom";

// const child ={
//   float: 'left',
//   padding: 0,
// };
// const buttonchildLink ={
//   float: 'left',
//   marginLeft: '100px',
// }; 
export const mapStateToWorkingBody = (state) => {
  const currentPolicy = state.policyReducer.selectedPolicy;
  const isInternationalOrSaga =
    currentPolicy && (currentPolicy.IsSaga || currentPolicy.IsInternational);
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const isChildOnly = currentPolicy?.IsChildOnlyPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    currentPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(currentMember.DateOfBirth);
  return{
    isLapsed,
    isInternationalOrSaga,
    layout: state.layoutReducer && state.layoutReducer.layout,
    isSMEModular: currentPolicy && currentPolicy.IsSMEModular,
    isLargeCorporate: currentPolicy && currentPolicy.IsLargeCorporate,
    isEDCA: currentPolicy && currentPolicy.IsEDCA,
    isIndividual :currentPolicy && currentPolicy.IsIndividual,
    isChildOnly: isChildOnly,
    membershipNumber : currentPolicy && currentPolicy.MembershipNumber,
    isAgeAbove18

  };
};

  
export class WorkingBody extends Component {
  async onMakeAnAppointmentButton(membershipNumber) {
    try {
      const newTab = window.open(Urls.AxaMakeAnAppointmentButton, "_blank");
      const response = await SendPolicyNumberToHBS(membershipNumber);
      console.log(response.data);
      newTab.location.href = response.data;
    }
    catch
    {
      window.open(Urls.AxaMakeAnAppointmentButton, "_blank");
    }
  }
  static content = Store.WorkingBody;
  render() {
   
     return (
      <>
      {this.props.isAgeAbove18?
      (<div className={styles.workingBody}>
        <OuterPrimaryContainer>
          <ImageHeroContainer
            bgImage={this.props.content.BackgroundDesktopImage}
            bgImageMobile={this.props.content.BackgroundMobileImage}
            bgImageTablet={this.props.content.BackgroundTabletImage}
            bgAlt="" 
            UniqueKey="whiteBox"
            LargeCorporate={this.props.isLargeCorporate}
            // Healthsupportline2="HealthsupportlineMSK"
          >
            {/* {this.props.content.HeroContent} */}
            {this.props.isLargeCorporate?this.props.content.LargeCorporate:this.props.content.HeroContent}
            {/* {this.props.content.HeroContentPhoneNumbers}
            {this.props.content.HeroContentContactHours} */}
            {/* <div className="col-lg-3 col-md-3 " style={child}>
              <StyledButton
                label={Store.WorkingBody.ButtonLeftLabel}
                buttonType ={this.props.layout === Layouts.MOL? "secondaryBlueButton" : "secondaryOrangeButtonSupportDCA"}
                onClick={ this.onMakeAnAppointmentButton}
                layout={this.props.layout}
              />
            </div>
            <div className="col-lg-3 col-md-3 " style={buttonchildLink}>
              <StyledButton
                label={Store.WorkingBody.ButtonRightLabel}
                buttonType ={this.props.layout === Layouts.MOL? "secondaryBlueButton" : "secondaryOrangeButtonSupportDCA"}
                onClick={() => {
                  Scroll.scroller.scrollTo(HOW_TO_BOOK_APPOINTMENT, {
                    duration: 750,
                    smooth: true
                  });
                }
                }
                layout={this.props.layout}
              />
            </div> */}
            <div className={"container " + btnStyles.buttonRowSpacing}>
              <div className="row">
                <div className="col-lg-12 p-0">

                  <StyledButton
                  id={ButtonConfig.MskMakeAppointmentContent}
                    buttonType={this.props.layout === Layouts.MOL ? "primaryBlueButton" : "secondaryOrangeButtonSupportDCA"}
                    label={Store.WorkingBody.ButtonLeftLabel}
                    Healthsupportline1='Healthsupportline'
                    onClick={() => this.onMakeAnAppointmentButton(this.props.membershipNumber)}
                    layout={this.props.layout}  
                    buttonColor='blue'      
                  />
                  <StyledButton
                    id={ButtonConfig.MskHowItswork}
                    buttonType={this.props.layout === Layouts.MOL ? "secondaryBlueButton" : "secondaryOrangeButton"}                
                    onClick={() => {
                      Scroll.scroller.scrollTo(HOW_TO_BOOK_APPOINTMENT, {
                        duration: 750,
                        smooth: true
                      });
                    }
                    }
                    label={Store.WorkingBody.ButtonRightLabel}
                    Healthsupportline1='Healthsupportline'
                    layout={this.props.layout}
                    buttonColor='White'
                    // styledOrange='styledOrangeButton' 
                    // styledblue = 'styledblueButton'                       
                  />

                </div>
              </div>
            </div>
          </ImageHeroContainer>
          <section  name={HOW_TO_BOOK_APPOINTMENT} className={styles.sectionSpacing}>
            <div
              id="puregymPromo"
              className={"col-sm-12 " + styles.puregymPromo}
            >
              <PromoImageCard                
                ImgSrc={this.props.content.PhysioSection.IconSrc}
                ImgSrcMobile={this.props.content.PhysioSection.IconSrcMobile}
                Heading={this.props.content.PhysioSection.Heading}
                Description={this.props.content.PhysioSection.Description}
                LeftImage={true}
                UniqueKey="AppointmentSection"
                UniqueButton = "AppointmentButton"
                layout={this.props.layout}
                membershipNumber={this.props.membershipNumber}
              />
            </div>
          </section>
          <section className={styles.sectionSpacing}>
            <div
              id="puregymPromo"
              className={"col-sm-12 " + styles.puregymPromo}
            >
              <PromoImageCard
                ImgSrc={this.props.content.AppointmentSection.IconSrc}
                ImgSrcMobile={this.props.content.AppointmentSection.IconSrcMobile}
                Heading={this.props.content.AppointmentSection.Heading}
                Description={this.props.content.AppointmentSection.Description}
                LeftImage={false}
                UniqueKey="AppointmentSection"
                membershipNumber={this.props.membershipNumber}
              />
            </div>
          </section>
          <section className={styles.sectionSpacingHelpSection}>
            <div className={styles.AppointmentHelpSection}>
            <div className={styles.AppointmentHelpSectionText}>
              {this.props.content.AppointmentHelpSection.AppointmentHelpText}
            </div>
            </div>
          </section>
       

{/* 
        <section className={styles.sectionSpacingHelpSection}>
            <h2 className={styles.workingBodyHeading}>
              {this.props.content.StepHeader}
            </h2>
            <NumberStepList>
              {this.props.content.StepGiveUsACall}
              {this.props.content.StepSpeakToPhysio}
              {this.props.content.StepTreatment}
            </NumberStepList>
          </section> */}

          <section className={styles.sectionSpacingHelpSection}>
            <HelpSection
              HeadingLinkTo={Paths.Help}
              HeadingLinkText={Store.GeneralPages.MSKHelpHeadingLinkText}
              MoreHelpLinkTo={Paths.Help}
              MoreHelpLinkText={Store.GeneralPages.GPMoreHelpLinkText}
              HelpSet={this.props.content.HelpSet}
              // Healthsupportline="Healthsupportline"
            />
            <a target="_blank" id={ButtonConfig.MskMore}  href={Urls.HbsFaqs} className={ this.props.layout ===Layouts.MOL? styles.LinkSectionText : styles.LinkSectionTextHOl}>
              {this.props.content.LinkSection.LinkText}
              <div className={styles.LinkSectionChild}>
                {this.props.layout ===Layouts.MOL ? this.props.content.LinkSection.LinkImag : this.props.content.LinkSection.LinkImagHol}
              </div>
            </a>
          </section> 
          <section className={styles.sectionSpacing}>
          <a target="_blank" href={Urls.Hbsprivacypolicy} className={ this.props.layout ===Layouts.MOL? styles.LinkSectionText : styles.LinkSectionTextHOl}>
              {this.props.content.LinkSection.HBSPrivacyPolicy}
              <div className={styles.LinkSectionChild}>
                {this.props.layout ===Layouts.MOL ? this.props.content.LinkSection.LinkImag : this.props.content.LinkSection.LinkImagHol}
              </div>
            </a>
          </section>
        
        </OuterPrimaryContainer>
      </div>):
      (<Redirect to={Paths.NotFound} />)}
      </>
    );
  }
};

WorkingBody.content = Store.WorkingBody;
export default connect(mapStateToWorkingBody)(
  Contentify(WorkingBody)
);

// export default Contentify(WorkingBody);